export default __webpack_public_path__ + "static/media/loc-arte-9.5e78ca2b.webp";